// extracted by mini-css-extract-plugin
export var emptyState = "_4s-d";
export var statCard = "_4s-c";
export var table = "_4s-0";
export var tableCell = "_4s-4";
export var tableCellClickable = "_4s-5 _4s-4";
export var tableCellDefault = "_4s-6 _4s-4";
export var tableCellEmpty = "_4s-8";
export var tableCellWithValue = "_4s-7";
export var tableContainer = "_4s-e";
export var tableHeaderWeight = "_4s-1";
export var tableHeaderZone = "_4s-2";
export var tableRowHeader = "_4s-3";
export var viewModeButton = "_4s-9";
export var viewModeButtonActive = "_4s-a _4s-9";
export var viewModeButtonInactive = "_4s-b _4s-9";